/**
 * Abrir um anexo do cofre da clínica.
 *
 * O endereço do anexo é **assinado e vence** — não existe URL permanente para
 * foto de paciente. Isso obriga a pedir o endereço na hora, e é aí que mora a
 * armadilha: `window.open` depois de um `await` chega fora do gesto do usuário
 * e o navegador bloqueia como pop-up. Por isso a aba é aberta **antes** da
 * espera, ainda dentro do clique, e só depois recebe o endereço.
 *
 * `opener` vai a nulo: a aba de destino não tem por que alcançar a aplicação.
 */
export async function abrirAnexo(endereco: () => Promise<string>): Promise<boolean> {
    const aba = window.open('', '_blank');
    if (!aba) return false;
    aba.opener = null;
    try {
        const url = await endereco();
        if (!url) {
            aba.close();
            return false;
        }
        aba.location.replace(url);
        return true;
    } catch (e) {
        aba.close();
        throw e;
    }
}
